import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  makeStyles,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Content from '../Content';

import { getService } from '../../reducers/service';

const useDialogStyles = makeStyles(() => ({
  dialogBox: {
    minHeight: '200px',
    minWidth: '50%',
  },
}));

function AddEditValidationRules(props) {
  const { open, closeAddEditDialog, dialogType, selectedRule } = props;

  const classes = useDialogStyles();
  const service = getService('ptsibrsvalidationrules');

  const [validationRule, setValidationRule] = useState({});

  const user = useSelector(state => state.user?.userData?.user?.Username);
  const categoryTypes = useSelector(state => state.dictionary?.CategoryTypes);

  const entityList = useMemo(() => {
    let entities = [];
    if (!categoryTypes || categoryTypes.length == 0) return [];

    categoryTypes.map(item => {
      if (item?.CategoryKey === 'ptsibrsvalidationrulesentity') entities.push(item?.CategoryCode);
    });

    return entities;
  }, [categoryTypes]);
  const versionList = useMemo(() => {
    let versions = [];
    if (!categoryTypes || categoryTypes.length == 0) return [];

    categoryTypes.map(item => {
      if (item?.CategoryKey === 'ptsibrsvalidationrulesversion') versions.push(item?.CategoryCode);
    });

    return versions;
  }, [categoryTypes]);

  useEffect(() => {
    if (dialogType === 'Edit' && selectedRule?.ptsIBRSValidationRuleID)
      setValidationRule(selectedRule);
    else setValidationRule({});
  }, [dialogType, selectedRule]);

  const handleChange = (fieldName, fieldValue) => {
    setValidationRule({
      ...validationRule,
      [fieldName]: fieldValue,
    });
  };

  const handleSave = () => {
    if (dialogType === 'Add') {
      service
        .create({ ...validationRule, CreatedBy: user, UpdatedBy: user })
        .then(() => closeAddEditDialog())
        .catch(err => console.log('Validation Rule create error: ', err));
    } else if (dialogType === 'Edit') {
      service
        .patch(validationRule?.ptsIBRSValidationRuleID, { ...validationRule, UpdatedBy: user })
        .then(() => closeAddEditDialog())
        .catch(err => console.log('Validation Rule update error: ', err));
    }
  };

  const renderValidationRuleDialog = () => {
    return (
      <Dialog
        open={open}
        onClose={closeAddEditDialog}
        classes={{
          paperWidthSm: classes.dialogBox,
        }}>
        <DialogTitle
          className="d-flex justify-content-between align-items-center"
          style={{ background: '#1976d2' }}>
          <span style={{ fontSize: '18px', color: 'white' }}>{dialogType} Validation Rule</span>
        </DialogTitle>
        <DialogContent>
          <Grid container item xs={12} style={{ marginTop: 10 }}>
            <Grid item xs={4} style={{ width: '100%' }}>
              <Box style={{ marginLeft: 10 }}>
                <TextField
                  autoComplete="hidden"
                  size="small"
                  id="standard-textfield-nibrs-code"
                  value={validationRule?.NIBRSCode || ''}
                  label="NIBRS Code"
                  placeholder="NIBRS Code"
                  variant="outlined"
                  style={{
                    width: '100%',
                  }}
                  onChange={event => handleChange(event.target.name, event.target.value)}
                  name="NIBRSCode"
                />
              </Box>
            </Grid>
            <Grid item xs={4} style={{ width: '100%' }}>
              <Box style={{ marginLeft: 10 }}>
                <Autocomplete
                  id="entity-codes"
                  size="small"
                  autoHighlight
                  autoSelect
                  value={validationRule?.Entity || ''}
                  onChange={(event, newValue) => {
                    handleChange('Entity', newValue || '');
                  }}
                  options={entityList || []}
                  getOptionLabel={option => option || ''}
                  getOptionSelected={(option, value) => option === value}
                  style={{ width: '100%' }}
                  renderInput={params => (
                    <TextField {...params} variant="outlined" label="Entity" />
                  )}
                />
              </Box>
            </Grid>
            <Grid item xs={4} style={{ width: '100%' }}>
              <Box style={{ marginLeft: 10 }}>
                <Autocomplete
                  id="entity-codes"
                  size="small"
                  autoHighlight
                  autoSelect
                  value={validationRule?.Version || ''}
                  onChange={(event, newValue) => {
                    handleChange('Version', newValue || '');
                  }}
                  options={versionList || []}
                  getOptionLabel={option => option || ''}
                  getOptionSelected={(option, value) => option === value}
                  style={{ width: '100%' }}
                  renderInput={params => (
                    <TextField {...params} variant="outlined" label="Version" />
                  )}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={12} style={{ width: '100%' }} className="pl-2 mb-2">
              <TextField
                autoComplete="hidden"
                size="small"
                id="standard-textfield-nibrs-error-message"
                value={validationRule?.ErrorMessage || ''}
                label="Error Message"
                placeholder="Error Message"
                variant="outlined"
                multiline={true}
                style={{
                  width: '100%',
                }}
                onChange={event => handleChange(event.target.name, event.target.value)}
                name="ErrorMessage"
                rows={3}
                rowsMax={10}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <div className=" mb-1">
            <Button variant="outlined" onClick={closeAddEditDialog}>
              Cancel
            </Button>
            <Button className="ml-2" variant="contained" color="secondary" onClick={handleSave}>
              {dialogType === 'Edit' ? 'Update' : 'Save'}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    );
  };

  return <Content>{renderValidationRuleDialog()}</Content>;
}

export default AddEditValidationRules;
